import React, { useState } from 'react';
import styles from './aiChatMessageInput.module.scss';
import classnames from 'classnames';
import { Form } from 'react-bootstrap';
import { BsSearch } from 'react-icons/bs';
import { AIConversation, AIConversationStatus } from 'v2/models';
import { TextareaAutosize } from '@mui/base/TextareaAutosize';

type callBackSearchText = (search: string, ai_conversation: number) => void;

interface AIChatMessageInputProps {
  onSearch: callBackSearchText;
  aiConversation: AIConversation;
}

const AIChatMessageInput = ({
  onSearch,
  aiConversation,
}: AIChatMessageInputProps) => {
  const [visibleSearchText, setVisibleSearchText] = useState('');

  const handleKeyPress = (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      if (visibleSearchText.trim()) {
        onSearch(visibleSearchText, aiConversation.id);
      }
      setVisibleSearchText('');
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setVisibleSearchText(event.target.value);

    if (event.target.selectionEnd === event.target.value.length) {
      event.target.scrollTop = event.target.scrollHeight;
    }
  };

  const isDisabled = [
    AIConversationStatus.QUEUED,
    AIConversationStatus.FAILED,
    AIConversationStatus.IN_PROCESS,
  ].includes(aiConversation.status);

  return (
    <Form.Group
      className={classnames(styles.writeMessageContainer, 'mb-0 d-flex')}
    >
      <TextareaAutosize
        placeholder="Ask a question..."
        className={classnames(styles.questionBox, styles.scrollBar)}
        onKeyDown={handleKeyPress}
        onChange={handleChange}
        value={visibleSearchText}
        data-testid="search-bar-field"
        data-cy="search:search-bar"
        disabled={isDisabled}
        maxRows={8}
        autoFocus={true}
      />
      <BsSearch className={styles.searchIcon} style={{ fill: '#285FCB' }} />
    </Form.Group>
  );
};

export default AIChatMessageInput;
